module.exports = __webpack_public_path__ + "static/media/spiderman-badge-desktop-tablet-01-ps4-05sep18en.6aa5b8df.png";